import { useCallback, useEffect, useMemo, useState } from 'react';

import isEmpty from 'lodash-es/isEmpty';

const useCheckboxGroupDropdown = (itemList, onChange, limit, alert) => {
  const [open, setOpen] = useState(false);
  const [currenItemList, setCurrentItemList] = useState(itemList);
  const [allChecked, setAllChecked] = useState(
    itemList.filter(({ disabled }) => !disabled).every((item) => item.checked)
  );
  const [checkedCount, setCheckedCount] = useState(0);

  useEffect(() => {
    if (limit && checkedCount > limit) {
      alert?.();
      setCheckedCount(0);
    }
  }, [alert, checkedCount, limit]);

  const handleAllCheckChange = useCallback(
    ({ target: { checked } }) => {
      setAllChecked(checked);
      setCurrentItemList(itemList.map((item) => ({ ...item, checked: !item.disabled ? checked : item.checked })));
    },
    [itemList]
  );

  const handleCheckboxChange = useCallback(
    (index, item) => {
      const items = [...currenItemList];
      items[index] = item;
      setCurrentItemList(items);
      setCheckedCount(items.filter(({ checked }) => checked).length);
      setAllChecked(items.filter(({ disabled }) => !disabled).every((item) => item.checked));
    },
    [currenItemList]
  );

  const handleSetOpen = (isOpen) => {
    if (isOpen) {
      setCurrentItemList(itemList);
      setAllChecked(itemList.filter(({ disabled }) => !disabled).every((item) => item.checked));
    }
    setOpen(isOpen);
  };

  const handleConfirm = useCallback(
    (e) => {
      onChange({ ...e, target: { ...e.target, value: currenItemList } }, currenItemList);
      setOpen(false);
    },
    [currenItemList, onChange]
  );

  const handleCancel = () => {
    setOpen(false);
  };

  const checkedItemLabelList = useMemo(() => {
    const checkedItemList = itemList.filter(({ checked }) => checked);

    if (isEmpty(checkedItemList)) {
      return ['선택'];
    }

    return checkedItemList.map?.(({ label }) => label);
  }, [itemList]);
  return {
    open,
    currenItemList,
    allChecked,
    handleAllCheckChange,
    handleCheckboxChange,
    handleSetOpen,
    handleConfirm,
    handleCancel,
    checkedItemLabelList,
  };
};

export default useCheckboxGroupDropdown;
